import React, { useState, useEffect, useCallback } from "react";
import cn from "classnames";
import styles from "./AvantagesNature.module.sass";
import Card from "../../../components/Card";
import TextInput from "../../../components/TextInput";
import DualButton from "../../../components/DualButton";

const AvantagesNature = ({ className, data, updateData, validationErrors = {} }) => {
  // Récupérer les données des avantages en nature
  const avantagesData = data?.contract?.avantagesNature || {};

  // États pour les champs d'avantages en nature
  const [montantParRepas, setMontantParRepas] = useState(avantagesData?.food_costs || "");
  const [montantLogement, setMontantLogement] = useState(avantagesData?.lodging_costs || "");
  const [hasOtherAdvantages, setHasOtherAdvantages] = useState(avantagesData?.other_avantage ? "Oui" : "Non");

  // État pour les messages
  const [calculationError, setCalculationError] = useState("");
  const [missingDataInfo, setMissingDataInfo] = useState("");

  // État pour suivre la validité du formulaire
  const [isFormValid, setIsFormValid] = useState(false);

  // Fonction de validation du formulaire
  const validateForm = useCallback(() => {
    // Champs obligatoires : montant par repas et montant logement
    const isMontantRepasValid = montantParRepas && montantParRepas.trim().length > 0;
    const isMontantLogementValid = montantLogement && montantLogement.trim().length > 0;

    const formValid = isMontantRepasValid && isMontantLogementValid;

    setIsFormValid(formValid);

    if (updateData) {
      updateData('isValid', formValid);
    }

    return formValid;
  }, [montantParRepas, montantLogement, updateData]);

  // Effet pour valider le formulaire à chaque changement
  useEffect(() => {
    validateForm();
  }, [validateForm]);

  // Gestionnaire pour les changements d'avantages en nature
  const handleAvantagesChange = (e) => {
    const { name, value } = e.target;

    if (updateData) {
      updateData('avantagesNature', { ...data.contract?.avantagesNature, [name]: value });
    }
  };

  // Gestionnaire pour les DualButton
  const handleDualButtonChange = (name, value) => {
    if (updateData) {
      const booleanValue = value === "Oui";
      updateData('avantagesNature', { ...data.contract?.avantagesNature, [name]: booleanValue });
    }
  };

  // Effet pour réinitialiser les messages lorsque les données changent
  useEffect(() => {
    setCalculationError("");
    setMissingDataInfo("");
  }, [montantParRepas, montantLogement, hasOtherAdvantages]);

  // Effet pour initialiser les données d'avantages en nature
  useEffect(() => {
    if (data?.contract?.avantagesNature) {
      console.log("Received data in AvantagesNature:", data.contract.avantagesNature);
      const avantages = data.contract.avantagesNature;
      setMontantParRepas(avantages.food_costs || "");
      setMontantLogement(avantages.lodging_costs || "");
      setHasOtherAdvantages(avantages.other_avantage ? "Oui" : "Non");
    }
  }, [data?.contract?.avantagesNature]);

  return (
    <>
      <Card className={cn(styles.card, className)} title="Avantages en nature" classTitle="title-blue">
        <div className={styles.group}>
          <TextInput
            className={styles.field}
            label="Montant par repas"
            name="food_costs"
            type="number"
            placeholder="0"
            value={montantParRepas}
            onChange={(e) => {
              setMontantParRepas(e.target.value);
              handleAvantagesChange(e);
            }}
            error={validationErrors.montant_par_repas}
            suffix="€/repas"
            required={true}
          />

          <TextInput
            className={styles.field}
            label="Montant pour le logement"
            name="lodging_costs"
            type="number"
            placeholder="0"
            value={montantLogement}
            onChange={(e) => {
              setMontantLogement(e.target.value);
              handleAvantagesChange(e);
            }}
            error={validationErrors.montant_logement}
            suffix="€/mois"
            required={true}
          />
        </div>

        <div className={styles.field}>
          <DualButton
            label="Existe-t-il d'autres avantages en nature ?"
            option1="Oui"
            option2="Non"
            value={hasOtherAdvantages}
            onChange={(value) => {
              setHasOtherAdvantages(value);
              handleDualButtonChange('other_avantage', value);
            }}
            multiSelect={false}
          />
        </div>

        {missingDataInfo && (
          <div className={styles.infoMessage}>{missingDataInfo}</div>
        )}

        {calculationError && (
          <div className={styles.errorMessage}>{calculationError}</div>
        )}
      </Card>
    </>
  );
};

export default AvantagesNature;
